import { InvestidorResponse, ParticipanteResponse } from 'common/genericTypes';
import { AutoComplete } from 'm2m.components';
import React from 'react';
import { Typography, Paper } from '@material-ui/core';
import _ from 'lodash';
import { addCpfCnpjMask } from 'utils/mask';
import { stripCpfCnpjFormatting } from 'utils/validation';
import { TextField as MUITextField } from '@material-ui/core';

interface Props {
    label: string;
    investidores: Array<InvestidorResponse>;
    investidor: InvestidorResponse | null;
    onChange: (investidor: InvestidorResponse | null) => void;
    error?: boolean;
    disabled?: boolean;
}

const InvestidorAutoComplete: React.FC<Props> = (props) => {
    const { label, investidores, investidor, onChange, error, disabled } = props;

    const filterInvestidores = (options: Array<InvestidorResponse>, value: string) => {
        var valueUpperCase = value.toUpperCase();
        const valueClean = stripCpfCnpjFormatting(value);
        return options.filter(
            (op) =>
                op.razaoSocial.toLocaleUpperCase().includes(valueUpperCase) ||
                (valueClean.length > 0 && stripCpfCnpjFormatting(op.cpfCnpj).includes(valueClean))
        );
    };

    return (
        <AutoComplete
            label={label}
            placeholder={'Pesquisar...'}
            options={investidores}
            getOptionLabel={(option: InvestidorResponse) => addCpfCnpjMask(option.cpfCnpj)}
            value={investidor}
            onChange={onChange}
            disabled={disabled}
            filterOptions={(options: Array<InvestidorResponse>, state) => filterInvestidores(options, state.inputValue)}
            filterSelectedOptions
            PaperComponent={({ children }) => <Paper style={{ width: '500px', height: '100%' }}>{children}</Paper>}
            renderOption={(option: InvestidorResponse) => (
                <div style={{ width: '100%' }}>
                    <div style={{ display: 'flex' }}>
                        <Typography style={{ margin: 'auto 12px' }}>{addCpfCnpjMask(option.cpfCnpj)}</Typography>
                    </div>
                    <div>
                        <Typography style={{ margin: 'auto 12px' }} variant="body2">
                            {option.razaoSocial}
                        </Typography>
                    </div>
                </div>
            )}
            helperText={investidor?.razaoSocial}
            renderInput={(params) => (
                <MUITextField {...params} label={label} variant="outlined" placeholder={'Pesquisar...'} error={error} />
            )}
        />
    );
};

export default InvestidorAutoComplete;
